"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const src_1 = require("@rover/ts-bootstrap/dist/src");
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const actions_1 = require("../../../../actions");
const reducers_1 = require("../../../../reducers");
const MobilePopover_1 = require("../../components/MobilePopover");
class FieldSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            updatedField: '',
            isEditingValue: false,
        };
        this.addField = this.addField.bind(this);
        this.cancelFieldAdd = this.cancelFieldAdd.bind(this);
        this.renderAddFieldForm = this.renderAddFieldForm.bind(this);
    }
    render() {
        const { activePopover, isPopoverModalFormOpen, device, updateActivePopover } = this.props;
        const { updatedField } = this.state;
        return device !== 'Mobile' ? (React.createElement("div", null,
            React.createElement("div", { style: { overflowY: 'scroll' } }, this.renderFieldList()),
            React.createElement(src_1.PopoverContainer, { id: "api-field-popover", targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', showPopover: activePopover === 'field-add', popoverProps: {
                    placement: 'right',
                    device: device,
                    navBarProperties: {
                        buttonLeft: 'Cancel',
                        buttonLeftCallback: this.cancelFieldAdd,
                        buttonRight: updatedField !== '' ? 'Add' : '',
                        buttonRightCallback: updatedField !== '' ? this.addField : undefined,
                    },
                    overlayClickHandler: () => this.setState({
                        isEditingValue: false,
                    }),
                }, onClick: () => updateActivePopover(activePopover === 'field-add' ? '' : 'field-add') },
                this.renderAddButton(),
                React.createElement("div", { style: { height: 96, overflowY: 'scroll' } }, this.renderAddFieldForm())))) : (React.createElement("div", null,
            this.renderFieldList(),
            this.renderAddButton(),
            activePopover === 'field-add' &&
                ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: {
                        buttonLeft: 'Cancel',
                        buttonLeftCallback: this.cancelFieldAdd,
                        buttonRight: updatedField !== '' ? 'Add' : '',
                        buttonRightCallback: updatedField !== '' ? this.addField : undefined,
                    } },
                    React.createElement("div", { style: {
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            overflowY: 'scroll',
                        } },
                        React.createElement(src_1.Text, { text: "Add Custom API Field", size: "h2", textStyle: { margin: 24, marginBottom: 8 } }),
                        this.renderAddFieldForm())), document.getElementById('mainModalLeft'))));
    }
    addField() {
        const { updatedField } = this.state;
        const { addEditableAPIField, closePopoverModalForm, device, updateActivePopover } = this.props;
        addEditableAPIField(updatedField);
        closePopoverModalForm();
        setTimeout(() => updateActivePopover(''), device === 'Mobile' ? 500 : 0);
        this.setState({ updatedField: '', isEditingValue: false });
    }
    cancelFieldAdd() {
        const { closePopoverModalForm, device, updateActivePopover } = this.props;
        this.setState({ updatedField: '', isEditingValue: false });
        closePopoverModalForm();
        setTimeout(() => updateActivePopover(''), device === 'Mobile' ? 500 : 0);
    }
    renderFieldList() {
        const { editableCampaign, removeEditableAPIField } = this.props;
        const { fields } = editableCampaign.trigger;
        const { Fragment } = React;
        return fields.map((field, index) => (React.createElement(Fragment, { key: index },
            React.createElement(src_1.List, null,
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    React.createElement("div", { style: {
                            height: 40,
                            width: 40,
                            borderRadius: 40,
                            border: 'none',
                            background: src_1.cloud,
                            marginRight: 16,
                            flex: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        } },
                        React.createElement(src_1.HashtagIcon, { fill: src_1.steel, height: "24", width: "24", viewBox: "0 0 20 20" })),
                    React.createElement(src_1.Text, { text: field, size: "medium" })),
                React.createElement(src_1.CircleCloseIcon, { fill: src_1.silver, onClick: (e) => {
                        e.stopPropagation();
                        removeEditableAPIField(index);
                    } })))));
    }
    renderAddFieldForm() {
        const { device } = this.props;
        const { updatedField } = this.state;
        return (React.createElement("div", { style: {
                flex: '1 1 auto',
                width: device !== 'Mobile' ? 394 : '100%',
                paddingBottom: device !== 'Mobile' ? 0 : 56,
                paddingLeft: device !== 'Mobile' ? 16 : 24,
                paddingRight: device !== 'Mobile' ? 16 : 24,
            }, onClick: (e) => {
                e.stopPropagation();
                this.setState({
                    isEditingValue: !this.state.isEditingValue,
                });
            } },
            React.createElement("div", { style: {
                    borderBottom: device === 'Mobile' ? `1px solid ${src_1.titanium}` : 0,
                } },
                React.createElement(src_1.TextInput, { id: "field-key-input", inputType: "FIELD", placeholder: "Field e.g. my_field", text: updatedField, isEditingText: this.state.isEditingValue, isRequired: true, media: device, startEditingText: () => null, fieldStyle: { borderBottom: 0, paddingBottom: 0 }, onInputChange: (text) => this.setState({
                        updatedField: text.replace(/^[^a-zA-Z_]*|[\W\s]*/g, ''),
                    }), updateText: () => (updatedField === '' ? undefined : this.addField()) }),
                React.createElement(src_1.Text, { text: "Letters, numbers and underscores", size: "small", label: true, textStyle: {
                        color: src_1.steel,
                    } }))));
    }
    renderAddButton() {
        const { device, updateActivePopover } = this.props;
        const { Fragment } = React;
        return (React.createElement(Fragment, null,
            React.createElement("div", { style: {
                    height: 24,
                    width: 4,
                    background: src_1.quartz,
                    marginLeft: 24,
                } }),
            React.createElement("div", { style: {
                    width: 145,
                    height: 24,
                    display: 'flex',
                    alignItems: 'center',
                } },
                React.createElement("div", { style: {
                        width: 24,
                        height: 24,
                        borderRadius: 4,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: src_1.turquoise,
                        marginRight: 8,
                        marginLeft: 14,
                    } },
                    React.createElement(src_1.PlusIcon, { fill: src_1.white })),
                React.createElement(src_1.Button, { text: "Add Field", mouseDownColors: {
                        active: src_1.turquoise,
                        inactive: src_1.aquamarine,
                    }, onClick: device !== 'Desktop' ? () => updateActivePopover('field-add') : undefined, type: "regular" }))));
    }
}
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    editableCampaign: reducers_1.getEditableCampaign(state),
    isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
});
const mapDispatchToProps = (dispatch) => ({
    updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
    closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    addEditableAPIField: (field) => dispatch(actions_1.addEditableAPIField(field)),
    removeEditableAPIField: (index) => dispatch(actions_1.removeEditableAPIField(index)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(FieldSelector);
